<div *ngIf="updateComplete" class="flex flex-row justify-center items-center">
  <mat-card class="mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
    <mat-card-content>
      <div class="flex flex-col gap-2">

        <div class="flex flex-col" *ngIf="userUpdateResult.updated" style="font-size: x-large">
          <span>Profile Updated</span>
          <div>
            <button type="button" class="m-8" mat-raised-button color="primary" routerLink="/home">Return</button>
          </div>
        </div>

        <div class="flex flex-col text-red-400" *ngIf="userUpdateResult.duplicate" style="font-size: x-large">
          <span>Login ID or email already exists. Profile changes not saved.</span>
        </div>

        <div class="flex flex-col text-red-400" *ngIf="!userUpdateResult.updated && !userUpdateResult.duplicate" style="font-size: x-large">
          <span>Profile Not Updated. Please contact program administrator</span>
          <div>
            <button type="button" class="m-8" mat-raised-button color="primary" routerLink="/contact">Contact Us</button>
          </div>
        </div>

      </div>
    </mat-card-content>
  </mat-card>
</div>

<div class="flex flex-row justify-center items-center" *ngIf="!updateComplete || userUpdateResult.duplicate">
  <mat-card class="w-1/2 sm:w-full mt-8" [ngClass]="{
        'bg-gray-700': settings.theme === 'dark',
        'bg-indigo-50': settings.theme === 'light'}">
    <mat-card-title>
      <span style="font-size: larger">User Profile</span>
    </mat-card-title>
    <mat-card-content>
      <div class="flex flex-col">
        <form [formGroup]="updateForm" (ngSubmit)="update()">
          <div class="flex flex-col gap-2">

            <mat-form-field>
              <mat-label>Login</mat-label>
              <input matInput formControlName="login">
            </mat-form-field>

            <mat-form-field>
              <mat-label>Email</mat-label>
              <input matInput placeholder="email@email.com" formControlName="email">
              <mat-error *ngIf="updateForm.get('email').hasError('email')">
                Not a valid email address
              </mat-error>
              <mat-error *ngIf="updateForm.get('email').hasError('required')">
                This field is required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Company</mat-label>
              <input matInput formControlName="company">
            </mat-form-field>

            <!-- <mat-form-field>
              <mat-label>Password</mat-label>
              <input matInput type="password" formControlName="password" title="(Requires upper & lower case, number and special characters. 8 characters min.)">
              <mat-error *ngIf="updateForm.get('password').hasError('required')">
                This field is required
              </mat-error>
              <mat-error *ngIf="updateForm.get('password').hasError('criteria')">
                Password requires upper & lower case, number and special characters. 8 characters min.
              </mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Confirm Password</mat-label>
              <input matInput type="password" formControlName="confirmPassword">
              <mat-error *ngIf="validatePasswordsMatch()">
                Passwords must match
              </mat-error>
            </mat-form-field> -->

            <mat-form-field>
              <mat-label>First Name</mat-label>
              <input matInput formControlName="firstName">
              <mat-error *ngIf="updateForm.get('firstName').hasError('required')">
                This field is required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Last Name</mat-label>
              <input matInput formControlName="lastName">
              <mat-error *ngIf="updateForm.get('lastName').hasError('required')">
                This field is required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Address</mat-label>
              <input matInput formControlName="address">
            </mat-form-field>

            <mat-form-field>
              <mat-label>City</mat-label>
              <input matInput formControlName="city">
            </mat-form-field>

            <mat-form-field>
              <mat-label>State</mat-label>
              <mat-select formControlName="state">
                <mat-option>-- None --</mat-option>
                <mat-option *ngFor="let state of states" value={{state}}>{{state}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Zipcode</mat-label>
              <input matInput placeholder="Ex: 99999 or 99999-9999 for US postal" formControlName="zip">
              <mat-error *ngIf="updateForm.get('zip').hasError('pattern')">
                Zipcode must be in format: 99999 or 99999-1234
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Phone</mat-label>
              <input matInput placeholder="Ex: 999-999-9999" formControlName="phone">
              <mat-error *ngIf="updateForm.get('phone').hasError('pattern')">
                Phone must be in format: 999-999-9999 x9999
              </mat-error>
              <mat-error *ngIf="updateForm.get('phone').hasError('required')">
                This field is required
              </mat-error>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Registration Date</mat-label>
              <input matInput formControlName="registrationDate">
            </mat-form-field>

            <div class="flex flex-row">
              <div><button type="submit" class="m-8" mat-raised-button color="primary">Update</button></div>
              <div><button type="button" class="m-8" mat-raised-button color="warn" routerLink="/lab-user-menu">Cancel</button></div>
            </div>

          </div>
        </form>
      </div>
    </mat-card-content>
  </mat-card>
</div>
